import * as bootstrap from "sard_core/vendor/assets/bootstrap/javascripts/bootstrap"

Ready(() => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })
})
